import * as React from 'react';

import cn from 'classnames';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';

const variants = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.2 },
    opacity: 1,
    zIndex: 10,
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1 },
    opacity: 0,
    zIndex: -10,
  },
};

const blurVariants = {
  open: {
    opacity: 1,
    backdropFilter: 'blur(5px)',
  },
  closed: {
    opacity: 0,
    backdropFilter: 'blur(0)',
  },
};

const itemVariants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 },
    },
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 },
    },
  },
};

const containerVariants = {
  open: {
    display: 'block',
  },
  closed: {
    display: 'none',
  },
};

const Path = props => <motion.path fill="transparent" strokeWidth="3" stroke="#fff" strokeLinecap="round" {...props} />;

const navSizes = 'absolute lg:-left-[calc(100vw-23px-40px)] sm:-left-[calc(100vw-23px-16px)] w-[100vw]';

export const MobileNavigation = ({ items, toggle }) => (
  <div className="max-h-[23px]">
    <button onClick={toggle}>
      <svg width="23" height="23" viewBox="0 0 23 23">
        <Path
          variants={{
            closed: { d: 'M 2 2.5 L 20 2.5' },
            open: { d: 'M 3 16.5 L 17 2.5' },
          }}
        />
        <Path
          d="M 2 9.423 L 20 9.423"
          variants={{
            closed: { opacity: 1 },
            open: { opacity: 0 },
          }}
          transition={{ duration: 0.1 }}
        />
        <Path
          variants={{
            closed: { d: 'M 2 16.346 L 20 16.346' },
            open: { d: 'M 3 2.5 L 17 16.346' },
          }}
        />
      </svg>
    </button>

    <motion.div variants={containerVariants} className="relative top-4 z-[9999] bg-black">
      <motion.div
        className={cn(
          'flex flex-col gap-5 border-b border-b-white bg-black pb-7 pt-7 text-white lg:px-7 sm:px-4',
          navSizes,
        )}
        variants={variants}
      >
        {items.map(({ title, anchor }, idx) => (
          <motion.div
            key={title}
            variants={itemVariants}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            className="font-bold text-white"
          >
            <Link
              className={cn(
                'relative cursor-pointer transition-all duration-700 before:absolute before:-left-4 before:top-[50%] before:h-1 before:w-1 before:rounded before:bg-transparent before:transition-all before:duration-700',
                idx === items.length - 1 && 'border-white',
              )}
              activeClass="active pl-4 before:!bg-demo-sa-green before:!left-1"
              to={anchor}
              spy={true}
              smooth={true}
              offset={-50}
              duration={500}
              onClick={toggle}
            >
              {title}
            </Link>
          </motion.div>
        ))}
      </motion.div>
      <motion.div onClick={toggle} className={cn('min-h-[100vh]', navSizes)} variants={blurVariants} />
    </motion.div>
  </div>
);
